export const GTM_ID = 'GTM-WT28QNZ';

const DATA_LAYER_BASE = {
  network: 'product',
  site: 'backoffice-pharma',
  language: 'fr',
};

export const buildDataLayer = (pharmacyId: string) => ({
  ...DATA_LAYER_BASE,
  idpharma: pharmacyId,
});
